export const TWO_FA_FAILED_CODE = "JSQGraphQLErrorCode.TWO_FACTOR_AUTHENTICATION_FAILED";
export const MFA_ATTEMPT_LIMIT_EXCEEDED_CODE = "JSQGraphQLErrorCode.MFA_ATTEMPT_LIMIT_EXCEEDED";
